module.exports = __webpack_public_path__ + "images/mobile/stars/event-53bf52a57b4b38052aa0a5bd1f21825c.png";